import { Component, ViewEncapsulation, ChangeDetectionStrategy } from "@angular/core";

import { OptionsElementAccessor } from "../options-accessor";

/**
 * Checkboxes allow users to select one or more items from a set. Checkboxes can turn an option on or off.
 *
 * Use checkboxes to:
 *
 * * Select one or more options from a list
 * * Present a list containing sub-selections
 * * Turn an item on or off in a desktop environment
 *
 * Checkboxes should be used instead of switches if multiple options can be selected from a list.
 *
 * Checkboxes can be used as an Angular `FormControl`, in both reactive and template driven forms.
 */
@Component({
  selector: "ui-input[type=checkbox]",
  templateUrl: "./checkbox.component.html",
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputCheckboxComponent extends OptionsElementAccessor {}
